import { APICore } from '../../helpers/api/apiCore';
import * as URL from "../../helpers/api/apiEndPoint"

const api = new APICore();


function stock(params: any): any {
    const { search, limit, pages } = params.data
    return api.get(`${URL.GET_STOCK}?search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}`);
}
function stockCreate(params: any): any {
    const { data } = params
    return api.create(URL.CREATE_STOCK, data);
}
function stockUpdate(params: any): any {
    const { data } = params
    return api.update(URL.UPDATE_STOCK, data);
}
function findTagInStock(params: any): any {
    const { tag } = params?.data
    return api.get(`${URL.FIND_TAG_IN_STOCK}?tagNumber=${tag}`);
}


export { stock, stockCreate, stockUpdate, findTagInStock }